import React, { Component } from "react";
import { Fade } from "react-reveal";
import { leadershipData } from "../../portfolio.js";
import "./LeadershipSection.css";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

// Role keys mapping
const roleKeyMap = {
  "The Head Priest": "head_priest",
  "Spiritual Services Coordinator": "spiritual_coordinator",
};

const LeadershipSectionContent = ({ theme, language }) => {
  return (
    <div className="leadership-main">
      <div className="leadership-header">
        <Fade bottom duration={1000} distance="40px">
          <h1 className="leadership-heading" style={{ color: theme.text }}>
            {getTranslation(language, "leadership_section")}
          </h1>
          <p
            className="leadership-subtitle"
            style={{ color: theme.secondaryText }}
          >
            {getTranslation(language, "leadership_section_desc")}
          </p>
        </Fade>
      </div>

      <div className="leadership-content">
        {/* Leaders */}
        <div className="leaders-section">
          {leadershipData.leaders.map((leader, index) => (
            <Fade key={index} bottom duration={1500} distance="40px">
              <div className="leader-card">
                <h3 style={{ color: theme.text }}>{leader.name}</h3>
                <p className="leader-role" style={{ color: theme.highlight }}>
                  {getTranslation(
                    language,
                    roleKeyMap[leader.role] || "head_priest"
                  )}
                </p>
                <div className="leader-contact">
                  <p style={{ color: theme.secondaryText }}>
                    📧 {getTranslation(language, "email_label")}:{" "}
                    <a
                      href={`mailto:${leader.email}`}
                      style={{ color: theme.highlight }}
                    >
                      {leader.email}
                    </a>
                  </p>
                  <p style={{ color: theme.secondaryText }}>
                    📱 {getTranslation(language, "phone_label")}: {leader.phone}
                  </p>
                </div>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </div>
  );
};

class LeadershipSection extends Component {
  render() {
    const theme = this.props.theme;
    const language = this.props.language;
    return <LeadershipSectionContent theme={theme} language={language} />;
  }
}

// Wrapper component to inject language from context
function LeadershipSectionWithLanguage(props) {
  const { language } = useLanguage();
  return <LeadershipSection {...props} language={language} />;
}

export default LeadershipSectionWithLanguage;
